export default "__VITE_ASSET__C$z7VaeT__"